export const LOGINLOG_LIST_REQUEST = 'LOGINLOG_LIST_REQUEST';

export const LOGINLOG_LIST = 'LOGINLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_LOGINLOG_PAGINATION = 'SET_LOGINLOG_PAGINATION';

export const LOGINLOG_PAGE_RESET = 'LOGINLOG_PAGE_RESET';
